import React from 'react'
import { Field } from 'formik'
import { useTranslation } from 'react-i18next'

const FormInput = (props) => {
  const { t } = useTranslation('translation', { useSuspense: false })

  return (
    <div className={`input-control ${props.error ? 'input-error' : 'input-none'}`}>
      <Field {...props.field} />
      { props.error && <span className='text-danger text-sm'>{t('required')}</span>}
    </div>
  )
}

export default FormInput